export default "__VITE_ASSET__DmEdpxiR__"